import { DocumentTextIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { Link } from 'react-router-dom';

import { cn } from '@/lib/utils';

interface MatterLinkProps {
  matterId: string;
  matterName: string;
  className?: string;
}

export const MatterLink: React.FC<MatterLinkProps> = ({
  matterId,
  matterName,
  className,
}) => {
  if (!matterId || !matterName) return null;

  return (
    <Link
      to={`/matters/${matterId}`}
      onClick={(e) => e.stopPropagation()}
      className={cn(
        'inline-flex items-center gap-1 text-[10px] text-gray-400 hover:text-gray-600 transition-colors group/matter',
        className,
      )}
      title={`View matter: ${matterName}`}
    >
      <DocumentTextIcon className="h-3 w-3 flex-shrink-0" />
      <span className="truncate max-w-[180px] group-hover/matter:underline">
        {matterName}
      </span>
    </Link>
  );
};
